"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var value_checker_1 = __importDefault(require("../../../../common/src/utils/validation/value_checker"));
var texts_1 = __importDefault(require("../../../../common/src/constrains/locale/texts"));
var object_utils_1 = __importDefault(require("../../../../common/src/utils/sales_force/object_utils"));
var SalesForceScheduledApplicationTemplate = /** @class */ (function () {
    function SalesForceScheduledApplicationTemplate() {
    }
    SalesForceScheduledApplicationTemplate.getContents = function (salesForceInfo) {
        return SalesForceScheduledApplicationTemplate.getKobetuContents(salesForceInfo) +
            SalesForceScheduledApplicationTemplate.getToUpgradeContents(salesForceInfo) +
            SalesForceScheduledApplicationTemplate.getEntryContents(salesForceInfo) +
            SalesForceScheduledApplicationTemplate.getBasicContents(salesForceInfo) +
            SalesForceScheduledApplicationTemplate.getOldStandardContents(salesForceInfo) +
            SalesForceScheduledApplicationTemplate.getMediumContents(salesForceInfo) +
            SalesForceScheduledApplicationTemplate.getStandardContents(salesForceInfo) +
            SalesForceScheduledApplicationTemplate.getProfessionalContents(salesForceInfo) +
            SalesForceScheduledApplicationTemplate.getUpgradeToStandardContents(salesForceInfo) +
            SalesForceScheduledApplicationTemplate.getMotionAiContents(salesForceInfo) +
            SalesForceScheduledApplicationTemplate.getAdditionalTabletContents(salesForceInfo) +
            SalesForceScheduledApplicationTemplate.getOralCareContents(salesForceInfo);
    };
    SalesForceScheduledApplicationTemplate.getKobetuContents = function (salesForceInfo) {
        console.log(salesForceInfo);
        if (value_checker_1.default.isBlank(salesForceInfo.kobetuPriceBook2Id)) {
            return '';
        }
        var result = '';
        if (salesForceInfo.useKobetuFreePeriod && salesForceInfo.useKobetuFreePeriod.length) {
            result += '□個別機能訓練(無料期間) \n';
            if (value_checker_1.default.isPresent(salesForceInfo.kobetuFreePriceBook2Id)) {
                result += "   \u3010\u7121\u6599\u671F\u9593\u3011\u4FA1\u683C\u8868: " + salesForceInfo.kobetuFreePriceBook2Name + "\n";
            }
            if (value_checker_1.default.isPresent(salesForceInfo.kobetuFreeProductId)) {
                result += "   \u3010\u7121\u6599\u671F\u9593\u3011\u5546\u54C1: " + salesForceInfo.kobetuFreeProductName + "\n";
            }
            if (value_checker_1.default.isPresent(salesForceInfo.kobetuFreePeriod)) {
                result += "   \u3010\u7121\u6599\u671F\u9593\u3011\u671F\u9593: " + SalesForceScheduledApplicationTemplate.getPeriodText(salesForceInfo.kobetuFreePeriod);
            }
            result += SalesForceScheduledApplicationTemplate.NEXT_SECTION;
        }
        result += '□個別機能訓練 \n';
        if (value_checker_1.default.isPresent(salesForceInfo.kobetuPriceBook2Id)) {
            result += "   \u4FA1\u683C\u8868: " + salesForceInfo.kobetuPriceBook2Name + "\n";
        }
        if (value_checker_1.default.isPresent(salesForceInfo.kobetuPriceBook2Description)) {
            result += "   \u4FA1\u683C\u8868(\u9867\u5BA2\u5411\u3051\u8868\u793A\u30E9\u30D9\u30EB): " + salesForceInfo.kobetuPriceBook2Description + "\n";
        }
        if (value_checker_1.default.isPresent(salesForceInfo.kobetuProductId)) {
            result += "   \u5546\u54C1: " + salesForceInfo.kobetuProductName + "\n";
        }
        if (value_checker_1.default.isPresent(salesForceInfo.kobetuPriceDefault)) {
            result += "   \u6A19\u6E96\u4FA1\u683C\uFF08\u7A0E\u629C\uFF09: " + salesForceInfo.kobetuPriceDefault + "\n";
        }
        if (value_checker_1.default.isPresent(salesForceInfo.kobetuPrice)) {
            result += "   \u8CA9\u58F2\u4FA1\u683C\uFF08\u7A0E\u629C\uFF09: " + salesForceInfo.kobetuPrice + "\n";
        }
        if (value_checker_1.default.isPresent(salesForceInfo.kobetuBunkatuFlg)) {
            result += "   \u5206\u5272\u306E\u6709\u7121: " + salesForceInfo.kobetuBunkatuFlg + "\n";
        }
        if (value_checker_1.default.isPresent(salesForceInfo.kobetuItFlg)) {
            result += "   IT\u5C0E\u5165\u88DC\u52A9\u91D1\u5229\u7528: " + salesForceInfo.kobetuItFlg + "\n";
        }
        if (value_checker_1.default.isPresent(salesForceInfo.kobetuPriceBookUrl)) {
            result += "   \u30AD\u30E3\u30F3\u30DA\u30FC\u30F3URL: " + salesForceInfo.kobetuPriceBookUrl + "\n";
        }
        if (value_checker_1.default.isPresent(salesForceInfo.kobetuTokubetuDetail)) {
            result += "   \u7279\u5225\u5BFE\u5FDC\u306E\u8A73\u7D30: " + salesForceInfo.kobetuTokubetuDetail;
        }
        result += SalesForceScheduledApplicationTemplate.NEXT_SECTION;
        return result;
    };
    SalesForceScheduledApplicationTemplate.getOralCareContents = function (salesForceInfo) {
        if (value_checker_1.default.isBlank(salesForceInfo.oralCarePriceBook2Id)) {
            return '';
        }
        var result = '';
        if (salesForceInfo.useOralCareFreePeriod && salesForceInfo.useOralCareFreePeriod.length) {
            result += '□口腔機能向上加算(無料期間) \n';
            if (value_checker_1.default.isPresent(salesForceInfo.oralCareFreePriceBook2Id)) {
                result += "   \u3010\u7121\u6599\u671F\u9593\u3011\u4FA1\u683C\u8868: " + salesForceInfo.oralCareFreePriceBook2Name + "\n";
            }
            if (value_checker_1.default.isPresent(salesForceInfo.oralCareFreeProductId)) {
                result += "   \u3010\u7121\u6599\u671F\u9593\u3011\u5546\u54C1: " + salesForceInfo.oralCareFreeProductName + "\n";
            }
            if (value_checker_1.default.isPresent(salesForceInfo.oralCareFreePeriod)) {
                result += "   \u3010\u7121\u6599\u671F\u9593\u3011\u671F\u9593: " + SalesForceScheduledApplicationTemplate.getPeriodText(salesForceInfo.oralCareFreePeriod);
            }
            result += SalesForceScheduledApplicationTemplate.NEXT_SECTION;
        }
        result += '□口腔機能向上加算 \n';
        if (value_checker_1.default.isPresent(salesForceInfo.oralCarePriceBook2Id)) {
            result += "   \u4FA1\u683C\u8868: " + salesForceInfo.oralCarePriceBook2Name + "\n";
        }
        if (value_checker_1.default.isPresent(salesForceInfo.oralCarePriceBook2Description)) {
            result += "   \u4FA1\u683C\u8868(\u9867\u5BA2\u5411\u3051\u8868\u793A\u30E9\u30D9\u30EB): " + salesForceInfo.oralCarePriceBook2Description + "\n";
        }
        if (value_checker_1.default.isPresent(salesForceInfo.oralCareProductId)) {
            result += "   \u5546\u54C1: " + salesForceInfo.oralCareProductName + "\n";
        }
        if (value_checker_1.default.isPresent(salesForceInfo.oralCarePriceDefault)) {
            result += "   \u6A19\u6E96\u4FA1\u683C\uFF08\u7A0E\u629C\uFF09: " + salesForceInfo.oralCarePriceDefault + "\n";
        }
        if (value_checker_1.default.isPresent(salesForceInfo.oralCcarePrice)) {
            result += "   \u8CA9\u58F2\u4FA1\u683C\uFF08\u7A0E\u629C\uFF09: " + salesForceInfo.oralCcarePrice + "\n";
        }
        if (value_checker_1.default.isPresent(salesForceInfo.oralCareBunkatuFlg)) {
            result += "   \u5206\u5272\u306E\u6709\u7121: " + salesForceInfo.oralCareBunkatuFlg + "\n";
        }
        if (value_checker_1.default.isPresent(salesForceInfo.oralCareItFlg)) {
            result += "   IT\u5C0E\u5165\u88DC\u52A9\u91D1\u5229\u7528: " + salesForceInfo.oralCareItFlg + "\n";
        }
        if (value_checker_1.default.isPresent(salesForceInfo.oralCarePriceBookUrl)) {
            result += "   \u30AD\u30E3\u30F3\u30DA\u30FC\u30F3URL: " + salesForceInfo.oralCarePriceBookUrl + "\n";
        }
        if (value_checker_1.default.isPresent(salesForceInfo.oralCareTokubetuDetail)) {
            result += "   \u7279\u5225\u5BFE\u5FDC\u306E\u8A73\u7D30: " + salesForceInfo.oralCareTokubetuDetail;
        }
        result += SalesForceScheduledApplicationTemplate.NEXT_SECTION;
        return result;
    };
    SalesForceScheduledApplicationTemplate.getToUpgradeContents = function (salesForceInfo) {
        if (value_checker_1.default.isBlank(salesForceInfo.toUpgradePriceBook2Id)) {
            return '';
        }
        var result = '';
        if (salesForceInfo.toUpgradeData) {
            result += object_utils_1.default.limitedPlanTexts("scheduled_application", salesForceInfo.toUpgradeData, salesForceInfo.toUpgradeSelectedItem, salesForceInfo.previousPlan, salesForceInfo.contractPlan, salesForceInfo.toUpgradeStartDate);
        }
        result += "   \u30A2\u30C3\u30D7\u30B0\u30EC\u30FC\u30C9\u5F8C: " + salesForceInfo.contractPlan + "\n";
        result += "   \u5546\u54C1: " + salesForceInfo.toUpgradePlanName + "\n";
        result += "   \u30D7\u30E9\u30F3\u9069\u7528\u671F\u9593: " + salesForceInfo.toUpradePlanPeriodStr + "\n";
        if (value_checker_1.default.isPresent(salesForceInfo.toUpgradePrice)) {
            result += "   \u8CA9\u58F2\u4FA1\u683C\uFF08\u7A0E\u629C\uFF09: " + salesForceInfo.toUpgradePrice + "\n";
        }
        if (value_checker_1.default.isPresent(salesForceInfo.toUpgradeItFlg)) {
            result += "   IT\u5C0E\u5165\u88DC\u52A9\u91D1\u5229\u7528: " + salesForceInfo.toUpgradeItFlg + "\n";
        }
        if (value_checker_1.default.isPresent(salesForceInfo.toUpgradeTokubetuDetail)) {
            result += "   \u7279\u5225\u5BFE\u5FDC\u306E\u8A73\u7D30: " + salesForceInfo.toUpgradeTokubetuDetail;
        }
        result += SalesForceScheduledApplicationTemplate.NEXT_SECTION;
        return result;
    };
    SalesForceScheduledApplicationTemplate.getBasicContents = function (salesForceInfo) {
        console.log(salesForceInfo);
        if (value_checker_1.default.isBlank(salesForceInfo.basicPriceBook2Id)) {
            return '';
        }
        var result = '';
        result += '□Rehab Cloud Basic \n';
        if (value_checker_1.default.isPresent(salesForceInfo.basicPriceBook2Id)) {
            result += "   \u4FA1\u683C\u8868: " + salesForceInfo.basicPriceBook2Name + "\n";
        }
        if (value_checker_1.default.isPresent(salesForceInfo.basicPriceBook2Description)) {
            result += "   \u4FA1\u683C\u8868(\u9867\u5BA2\u5411\u3051\u8868\u793A\u30E9\u30D9\u30EB): " + salesForceInfo.basicPriceBook2Description + "\n";
        }
        if (value_checker_1.default.isPresent(salesForceInfo.basicProductId)) {
            result += "   \u5546\u54C1: " + salesForceInfo.basicProductName + "\n";
        }
        if (value_checker_1.default.isPresent(salesForceInfo.basicPriceDefault)) {
            result += "   \u6A19\u6E96\u4FA1\u683C\uFF08\u7A0E\u629C\uFF09: " + salesForceInfo.basicPriceDefault + "\n";
        }
        if (value_checker_1.default.isPresent(salesForceInfo.basicPrice)) {
            result += "   \u8CA9\u58F2\u4FA1\u683C\uFF08\u7A0E\u629C\uFF09: " + salesForceInfo.basicPrice + "\n";
        }
        if (value_checker_1.default.isPresent(salesForceInfo.basicBunkatuFlg)) {
            result += "   \u5206\u5272\u306E\u6709\u7121: " + salesForceInfo.basicBunkatuFlg + "\n";
        }
        if (value_checker_1.default.isPresent(salesForceInfo.basicItFlg)) {
            result += "   IT\u5C0E\u5165\u88DC\u52A9\u91D1\u5229\u7528: " + salesForceInfo.basicItFlg + "\n";
        }
        if (value_checker_1.default.isPresent(salesForceInfo.basicPriceBookUrl)) {
            result += "   \u30AD\u30E3\u30F3\u30DA\u30FC\u30F3URL: " + salesForceInfo.basicPriceBookUrl + "\n";
        }
        if (value_checker_1.default.isPresent(salesForceInfo.basicTokubetuDetail)) {
            result += "   \u7279\u5225\u5BFE\u5FDC\u306E\u8A73\u7D30: " + salesForceInfo.basicTokubetuDetail;
        }
        result += SalesForceScheduledApplicationTemplate.NEXT_SECTION;
        return result;
    };
    SalesForceScheduledApplicationTemplate.getEntryContents = function (salesForceInfo) {
        if (value_checker_1.default.isBlank(salesForceInfo.entryPriceBook2Id)) {
            return '';
        }
        var result = '';
        result += '□Rehab Cloud Entry \n';
        if (value_checker_1.default.isPresent(salesForceInfo.entryPriceBook2Id)) {
            result += "   \u4FA1\u683C\u8868: " + salesForceInfo.entryPriceBook2Name + "\n";
        }
        if (value_checker_1.default.isPresent(salesForceInfo.entryPriceBook2Description)) {
            result += "   \u4FA1\u683C\u8868(\u9867\u5BA2\u5411\u3051\u8868\u793A\u30E9\u30D9\u30EB): " + salesForceInfo.entryPriceBook2Description + "\n";
        }
        if (value_checker_1.default.isPresent(salesForceInfo.entryProductId)) {
            result += "   \u5546\u54C1: " + salesForceInfo.entryProductName + "\n";
        }
        if (value_checker_1.default.isPresent(salesForceInfo.entryPriceDefault)) {
            result += "   \u6A19\u6E96\u4FA1\u683C\uFF08\u7A0E\u629C\uFF09: " + salesForceInfo.entryPriceDefault + "\n";
        }
        if (value_checker_1.default.isPresent(salesForceInfo.entryPrice)) {
            result += "   \u8CA9\u58F2\u4FA1\u683C\uFF08\u7A0E\u629C\uFF09: " + salesForceInfo.entryPrice + "\n";
        }
        if (value_checker_1.default.isPresent(salesForceInfo.entryBunkatuFlg)) {
            result += "   \u5206\u5272\u306E\u6709\u7121: " + salesForceInfo.entryBunkatuFlg + "\n";
        }
        if (value_checker_1.default.isPresent(salesForceInfo.entryItFlg)) {
            result += "   IT\u5C0E\u5165\u88DC\u52A9\u91D1\u5229\u7528: " + salesForceInfo.entryItFlg + "\n";
        }
        // 現状使う予定なし。
        // if (ValueChecker.isPresent(salesForceInfo.entryPriceBookUrl)) {
        //     result += `   キャンペーンURL: ${salesForceInfo.entryPriceBookUrl}\n`;
        // }
        if (value_checker_1.default.isPresent(salesForceInfo.entryTokubetuDetail)) {
            result += "   \u7279\u5225\u5BFE\u5FDC\u306E\u8A73\u7D30: " + salesForceInfo.entryTokubetuDetail;
        }
        result += SalesForceScheduledApplicationTemplate.NEXT_SECTION;
        return result;
    };
    SalesForceScheduledApplicationTemplate.getMediumContents = function (salesForceInfo) {
        if (value_checker_1.default.isBlank(salesForceInfo.mediumPriceBook2Id)) {
            return '';
        }
        var result = '';
        result += '□Rehab Cloud Medium \n';
        if (value_checker_1.default.isPresent(salesForceInfo.mediumPriceBook2Id)) {
            result += "   \u4FA1\u683C\u8868: " + salesForceInfo.mediumPriceBook2Name + "\n";
        }
        if (value_checker_1.default.isPresent(salesForceInfo.mediumPriceBook2Description)) {
            result += "   \u4FA1\u683C\u8868(\u9867\u5BA2\u5411\u3051\u8868\u793A\u30E9\u30D9\u30EB): " + salesForceInfo.mediumPriceBook2Description + "\n";
        }
        if (value_checker_1.default.isPresent(salesForceInfo.mediumProductId)) {
            result += "   \u5546\u54C1: " + salesForceInfo.mediumProductName + "\n";
        }
        if (value_checker_1.default.isPresent(salesForceInfo.mediumPriceDefault)) {
            result += "   \u6A19\u6E96\u4FA1\u683C\uFF08\u7A0E\u629C\uFF09: " + salesForceInfo.mediumPriceDefault + "\n";
        }
        if (value_checker_1.default.isPresent(salesForceInfo.mediumPrice)) {
            result += "   \u8CA9\u58F2\u4FA1\u683C\uFF08\u7A0E\u629C\uFF09: " + salesForceInfo.mediumPrice + "\n";
        }
        if (value_checker_1.default.isPresent(salesForceInfo.mediumBunkatuFlg)) {
            result += "   \u5206\u5272\u306E\u6709\u7121: " + salesForceInfo.mediumBunkatuFlg + "\n";
        }
        if (value_checker_1.default.isPresent(salesForceInfo.mediumItFlg)) {
            result += "   IT\u5C0E\u5165\u88DC\u52A9\u91D1\u5229\u7528: " + salesForceInfo.mediumItFlg + "\n";
        }
        // 現状使う予定なし。
        // if (ValueChecker.isPresent(salesForceInfo.mediumPriceBookUrl)) {
        //     result += `   キャンペーンURL: ${salesForceInfo.mediumPriceBookUrl}\n`;
        // }
        if (value_checker_1.default.isPresent(salesForceInfo.mediumTokubetuDetail)) {
            result += "   \u7279\u5225\u5BFE\u5FDC\u306E\u8A73\u7D30: " + salesForceInfo.mediumTokubetuDetail;
        }
        result += SalesForceScheduledApplicationTemplate.NEXT_SECTION;
        return result;
    };
    SalesForceScheduledApplicationTemplate.getOldStandardContents = function (salesForceInfo) {
        if (value_checker_1.default.isBlank(salesForceInfo.oldStandardPriceBook2Id)) {
            return '';
        }
        var result = '';
        result += '□Rehab Cloud Standard(2024年4月よりMedium) \n';
        if (value_checker_1.default.isPresent(salesForceInfo.oldStandardPriceBook2Id)) {
            result += "   \u4FA1\u683C\u8868: " + salesForceInfo.oldStandardPriceBook2Name + "\n";
        }
        if (value_checker_1.default.isPresent(salesForceInfo.oldStandardPriceBook2Description)) {
            result += "   \u4FA1\u683C\u8868(\u9867\u5BA2\u5411\u3051\u8868\u793A\u30E9\u30D9\u30EB): " + salesForceInfo.oldStandardPriceBook2Description + "\n";
        }
        if (value_checker_1.default.isPresent(salesForceInfo.oldStandardProductId)) {
            result += "   \u5546\u54C1: " + salesForceInfo.oldStandardProductName + "\n";
        }
        if (value_checker_1.default.isPresent(salesForceInfo.oldStandardPriceDefault)) {
            result += "   \u6A19\u6E96\u4FA1\u683C\uFF08\u7A0E\u629C\uFF09: " + salesForceInfo.oldStandardPriceDefault + "\n";
        }
        if (value_checker_1.default.isPresent(salesForceInfo.oldStandardPrice)) {
            result += "   \u8CA9\u58F2\u4FA1\u683C\uFF08\u7A0E\u629C\uFF09: " + salesForceInfo.oldStandardPrice + "\n";
        }
        if (value_checker_1.default.isPresent(salesForceInfo.oldStandardBunkatuFlg)) {
            result += "   \u5206\u5272\u306E\u6709\u7121: " + salesForceInfo.oldStandardBunkatuFlg + "\n";
        }
        if (value_checker_1.default.isPresent(salesForceInfo.oldStandardItFlg)) {
            result += "   IT\u5C0E\u5165\u88DC\u52A9\u91D1\u5229\u7528: " + salesForceInfo.oldStandardItFlg + "\n";
        }
        if (value_checker_1.default.isPresent(salesForceInfo.oldStandardPriceBookUrl)) {
            result += "   \u30AD\u30E3\u30F3\u30DA\u30FC\u30F3URL: " + salesForceInfo.oldStandardPriceBookUrl + "\n";
        }
        if (value_checker_1.default.isPresent(salesForceInfo.oldStandardTokubetuDetail)) {
            result += "   \u7279\u5225\u5BFE\u5FDC\u306E\u8A73\u7D30: " + salesForceInfo.oldStandardTokubetuDetail;
        }
        result += SalesForceScheduledApplicationTemplate.NEXT_SECTION;
        return result;
    };
    SalesForceScheduledApplicationTemplate.getStandardContents = function (salesForceInfo) {
        console.log(salesForceInfo);
        if (value_checker_1.default.isBlank(salesForceInfo.standardPriceBook2Id)) {
            return '';
        }
        var result = '';
        result += '□Rehab Cloud Standard \n';
        if (value_checker_1.default.isPresent(salesForceInfo.standardPriceBook2Id)) {
            result += "   \u4FA1\u683C\u8868: " + salesForceInfo.standardPriceBook2Name + "\n";
        }
        if (value_checker_1.default.isPresent(salesForceInfo.standardPriceBook2Description)) {
            result += "   \u4FA1\u683C\u8868(\u9867\u5BA2\u5411\u3051\u8868\u793A\u30E9\u30D9\u30EB): " + salesForceInfo.standardPriceBook2Description + "\n";
        }
        if (value_checker_1.default.isPresent(salesForceInfo.standardProductId)) {
            result += "   \u5546\u54C1: " + salesForceInfo.standardProductName + "\n";
        }
        if (value_checker_1.default.isPresent(salesForceInfo.standardPriceDefault)) {
            result += "   \u6A19\u6E96\u4FA1\u683C\uFF08\u7A0E\u629C\uFF09: " + salesForceInfo.standardPriceDefault + "\n";
        }
        if (value_checker_1.default.isPresent(salesForceInfo.standardPrice)) {
            result += "   \u8CA9\u58F2\u4FA1\u683C\uFF08\u7A0E\u629C\uFF09: " + salesForceInfo.standardPrice + "\n";
        }
        if (value_checker_1.default.isPresent(salesForceInfo.standardBunkatuFlg)) {
            result += "   \u5206\u5272\u306E\u6709\u7121: " + salesForceInfo.standardBunkatuFlg + "\n";
        }
        if (value_checker_1.default.isPresent(salesForceInfo.standardItFlg)) {
            result += "   IT\u5C0E\u5165\u88DC\u52A9\u91D1\u5229\u7528: " + salesForceInfo.standardItFlg + "\n";
        }
        if (value_checker_1.default.isPresent(salesForceInfo.standardPriceBookUrl)) {
            result += "   \u30AD\u30E3\u30F3\u30DA\u30FC\u30F3URL: " + salesForceInfo.standardPriceBookUrl + "\n";
        }
        if (value_checker_1.default.isPresent(salesForceInfo.standardTokubetuDetail)) {
            result += "   \u7279\u5225\u5BFE\u5FDC\u306E\u8A73\u7D30: " + salesForceInfo.standardTokubetuDetail;
        }
        result += SalesForceScheduledApplicationTemplate.NEXT_SECTION;
        return result;
    };
    SalesForceScheduledApplicationTemplate.getProfessionalContents = function (salesForceInfo) {
        if (value_checker_1.default.isBlank(salesForceInfo.professionalPriceBook2Id)) {
            return '';
        }
        var result = '';
        result += '□Rehab Cloud Pro \n';
        if (value_checker_1.default.isPresent(salesForceInfo.professionalPriceBook2Id)) {
            result += "   \u4FA1\u683C\u8868: " + salesForceInfo.professionalPriceBook2Name + "\n";
        }
        if (value_checker_1.default.isPresent(salesForceInfo.professionalPriceBook2Description)) {
            result += "   \u4FA1\u683C\u8868(\u9867\u5BA2\u5411\u3051\u8868\u793A\u30E9\u30D9\u30EB): " + salesForceInfo.professionalPriceBook2Description + "\n";
        }
        if (value_checker_1.default.isPresent(salesForceInfo.professionalProductId)) {
            result += "   \u5546\u54C1: " + salesForceInfo.professionalProductName + "\n";
        }
        if (value_checker_1.default.isPresent(salesForceInfo.professionalPriceDefault)) {
            result += "   \u6A19\u6E96\u4FA1\u683C\uFF08\u7A0E\u629C\uFF09: " + salesForceInfo.professionalPriceDefault + "\n";
        }
        if (value_checker_1.default.isPresent(salesForceInfo.professionalPrice)) {
            result += "   \u8CA9\u58F2\u4FA1\u683C\uFF08\u7A0E\u629C\uFF09: " + salesForceInfo.professionalPrice + "\n";
        }
        if (value_checker_1.default.isPresent(salesForceInfo.professionalBunkatuFlg)) {
            result += "   \u5206\u5272\u306E\u6709\u7121: " + salesForceInfo.professionalBunkatuFlg + "\n";
        }
        if (value_checker_1.default.isPresent(salesForceInfo.professionalItFlg)) {
            result += "   IT\u5C0E\u5165\u88DC\u52A9\u91D1\u5229\u7528: " + salesForceInfo.professionalItFlg + "\n";
        }
        // 現状使う予定なし。
        // if (ValueChecker.isPresent(salesForceInfo.professionalPriceBookUrl)) {
        //     result += `   キャンペーンURL: ${salesForceInfo.professionalPriceBookUrl}\n`;
        // }
        if (value_checker_1.default.isPresent(salesForceInfo.professionalTokubetuDetail)) {
            result += "   \u7279\u5225\u5BFE\u5FDC\u306E\u8A73\u7D30: " + salesForceInfo.professionalTokubetuDetail;
        }
        result += SalesForceScheduledApplicationTemplate.NEXT_SECTION;
        return result;
    };
    SalesForceScheduledApplicationTemplate.getUpgradeToStandardContents = function (salesForceInfo) {
        if (value_checker_1.default.isBlank(salesForceInfo.validUpgradeToStandardFlg)) {
            return '';
        }
        var result = '';
        result += '□Rehab Cloud アップグレード \n';
        if (value_checker_1.default.isPresent(salesForceInfo.upgradeToStandardItFlg)) {
            result += "   IT\u5C0E\u5165\u88DC\u52A9\u91D1\u5229\u7528: " + salesForceInfo.upgradeToStandardItFlg + "\n";
        }
        if (value_checker_1.default.isPresent(salesForceInfo.upgradeToStandardTokubetuDetail)) {
            result += "   \u7279\u5225\u5BFE\u5FDC\u306E\u8A73\u7D30: " + salesForceInfo.upgradeToStandardTokubetuDetail + "\n";
        }
        result += SalesForceScheduledApplicationTemplate.NEXT_SECTION;
        return result;
    };
    SalesForceScheduledApplicationTemplate.getAdditionalTabletContents = function (salesForceInfo) {
        if (value_checker_1.default.isBlank(salesForceInfo.additionalTabletPriceBook2Id)) {
            return '';
        }
        var result = '';
        result += '□Rehab Cloud タブレット 追加お申し込み \n';
        if (value_checker_1.default.isPresent(salesForceInfo.additionalTablets)) {
            result += "----------------------------------------------------------------------------------------\n";
            result += "   Rehab Cloud \u30BF\u30D6\u30EC\u30C3\u30C8\u521D\u56DE\u624B\u6570\u6599\uFF1A" + salesForceInfo.additionalTablets + "\u53F0 \n";
            result += "   Rehab Cloud \u30BF\u30D6\u30EC\u30C3\u30C8\u521D\u56DE\u624B\u6570\u6599\uFF1A\u00A5" + salesForceInfo.displayDataTableObj.initialFeeTotalPrice + "\uFF08\u521D\u6708\u306E\u307F\uFF09 \n";
            result += "   Rehab Cloud \u30BF\u30D6\u30EC\u30C3\u30C8\uFF1A\u00A5" + salesForceInfo.displayDataTableObj.tabletsTotalPrice + "\n";
            result += "----------------------------------------------------------------------------------------\n";
        }
        if (value_checker_1.default.isPresent(salesForceInfo.additionalTabletTokubetuDetail)) {
            result += "   \u7279\u5225\u5BFE\u5FDC\u306E\u8A73\u7D30: " + salesForceInfo.additionalTabletTokubetuDetail + "\n";
        }
        result += SalesForceScheduledApplicationTemplate.NEXT_SECTION;
        return result;
    };
    SalesForceScheduledApplicationTemplate.getMotionAiContents = function (salesForceInfo) {
        if (value_checker_1.default.isBlank(salesForceInfo.motionAiPriceBook2Id)) {
            return '';
        }
        var result = '';
        result += '□Rehab Cloud モーションAI \n';
        if (value_checker_1.default.isPresent(salesForceInfo.motionAiPriceBook2Id)) {
            result += "   \u4FA1\u683C\u8868: " + salesForceInfo.motionAiPriceBook2Name + "\n";
        }
        if (value_checker_1.default.isPresent(salesForceInfo.motionAiPriceBook2Description)) {
            result += "   \u4FA1\u683C\u8868(\u9867\u5BA2\u5411\u3051\u8868\u793A\u30E9\u30D9\u30EB): " + salesForceInfo.motionAiPriceBook2Description + "\n";
        }
        if (value_checker_1.default.isPresent(salesForceInfo.motionAiProductId)) {
            result += "   \u5546\u54C1: " + salesForceInfo.motionAiProductName + "\n";
        }
        if (value_checker_1.default.isPresent(salesForceInfo.motionAiPriceDefault)) {
            result += "   \u6A19\u6E96\u4FA1\u683C\uFF08\u7A0E\u629C\uFF09: " + salesForceInfo.motionAiPriceDefault + "\n";
        }
        if (value_checker_1.default.isPresent(salesForceInfo.motionAiPrice)) {
            result += "   \u8CA9\u58F2\u4FA1\u683C\uFF08\u7A0E\u629C\uFF09: " + salesForceInfo.motionAiPrice + "\n";
        }
        if (value_checker_1.default.isPresent(salesForceInfo.motionAiItFlg)) {
            result += "   IT\u5C0E\u5165\u88DC\u52A9\u91D1\u5229\u7528: " + salesForceInfo.motionAiItFlg + "\n";
        }
        // if (ValueChecker.isPresent(salesForceInfo.motionAiPriceBookUrl)) {
        //     result += `   キャンペーンURL: ${salesForceInfo.motionAiPriceBookUrl}\n`;
        // }
        if (value_checker_1.default.isPresent(salesForceInfo.motionAiTokubetuDetail)) {
            result += "   \u7279\u5225\u5BFE\u5FDC\u306E\u8A73\u7D30: " + salesForceInfo.motionAiTokubetuDetail;
        }
        result += SalesForceScheduledApplicationTemplate.NEXT_SECTION;
        return result;
    };
    SalesForceScheduledApplicationTemplate.getPeriodText = function (periodValue) {
        var result = texts_1.default.ja.view.sales_force.reflect.data_labels.opportunity.free_period.filter(function (freePeriod) {
            return freePeriod['value'] === periodValue;
        });
        if (result.length) {
            return result[0]['text'];
        }
        else {
            return '';
        }
    };
    Object.defineProperty(SalesForceScheduledApplicationTemplate, "NEXT_SECTION", {
        get: function () {
            return '\n\n';
        },
        enumerable: true,
        configurable: true
    });
    return SalesForceScheduledApplicationTemplate;
}());
exports.default = SalesForceScheduledApplicationTemplate;



//////////////////
// WEBPACK FOOTER
// ./src/utils/sales_force/template/scheduled_application.ts
// module id = 7JXL
// module chunks = 1